/**
 * Gets and returns the suitable print grid size based on the print scale.
 */
export default function setPrintGrid(printScale) {

    let size = 10;
    printScale = parseInt(printScale);
    if (printScale < 499) { 
        size = 10;
    } else if (printScale >= 500 && printScale <= 999){
        size = 50;
    } else if (printScale >= 1000 && printScale <= 3999){
        size = 100;
    } else if (printScale >= 4000 && printScale <= 9999){
        size = 500;
    } else if (printScale >= 10000 && printScale <= 79999){
        size = 1000;
    } else if (printScale >= 80000 && printScale <= 300000){
        size = 10000;
    }

    const grid = {};
    grid.size = size;
    grid.lineWidth = 0.5;
    grid.red = 0;
    grid.green = 0;
    grid.blue = 0;
    grid.fontsize = 6;

    return grid;

}